import { CSSProperties, useEffect } from 'react'
import styles from './Checkbox.module.css'
import stylelessCheckIcon from '../../assets/icons/styleless-check.svg'
import stylelessBlackCheckIcon from '../../assets/icons/styleless-black-check.svg'

type CheckboxProps = {
    label?: string;
    checked: boolean;
    signal?: boolean;
    fontSize?: number;
    onChange?: (newValue: boolean) => void;
    height?: number;
    labelPosition?: 'row' | 'row-reverse';
    spacing?: number;
    loading?: boolean;
    color?: string;
    className?: string;
    style?: CSSProperties;
}

function Checkbox({ label, checked, onChange, labelPosition = 'row', signal, fontSize,
        spacing = 6, loading, color = 'black', height = 20, className, style }: CheckboxProps) {

    function beforeChange(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        e.stopPropagation();
        onChange && onChange(!checked);
    }

    useEffect(() => {
        signal && onChange && onChange(signal);
    }, [signal])

    return (
        <div 
            onClick={beforeChange}
            className={`${styles.wrapper} ${className}`} 
            style={{ 
                columnGap: spacing, 
                flexDirection: labelPosition,
                ...style
            }}
        >
            <div className={styles.layout}>
                <svg width={height} height={height}>
                    {!loading && <circle cx={10} cy={10} fill='transparent' stroke={color} strokeWidth={2} r={8.5}/>}

                    <circle cx={10} cy={10} fill={color} strokeWidth={1} r={loading ? 0 : (checked ? 8 : 0)}/>

                    {loading && 
                    <circle cx={10} cy={10} fill='transparent' stroke={color} strokeWidth={2} r={8.5}
                            className={styles.spinning}
                            strokeDasharray={`${0.65 * 26.7035}, ${1.2 * 26.7035}`}/>}
                </svg>

                {checked &&
                    <img 
                        alt='check'
                        width={11} height={11}
                        src={color !== 'black' ? stylelessBlackCheckIcon : stylelessCheckIcon}   
                        className={styles.check}
                        style={{ left: color !== 'black' ? '5px' : '' }}    
                    />
                }
            </div>

            <span className={styles.label} style={{ fontSize: fontSize ? fontSize + 'px' : '' }}>{label}</span>
        </div>
    )
}

export default Checkbox;